import { Button } from "@faire/slate/components/button";
import {
  BaseModal,
  BaseModalBody,
  BaseModalFooter,
  BaseModalHeader,
} from "@faire/slate/components/modal/base";
import type { ReactNode } from "react";

interface TermsModalProps {
  open: boolean;
  onClose: () => void;
}

export const TermsModal = ({ open, onClose }: TermsModalProps): ReactNode => (
  <BaseModal open={open} onClose={onClose} size="small">
    <BaseModalHeader title="Welcome offer terms" />
    <BaseModalBody>
      <div className="flex flex-col gap-(--slate-spacing-group-large)">
        <p className="type-fs-paragraph text-fs-text-primary">
          Get 50% off eligible products on your first order, up to a maximum
          discount of $100. The discount is applied automatically at checkout.
        </p>
        <p className="type-fs-paragraph text-fs-text-primary">
          The offer expires August 12, 2026 at 11:59 PM EDT and cannot be
          combined with another first-order promotion.
        </p>
        <p className="type-fs-label text-fs-text-subdued">
          Prototype terms shown for interaction testing only.
        </p>
      </div>
    </BaseModalBody>
    <BaseModalFooter>
      <Button onClick={onClose}>Got it</Button>
    </BaseModalFooter>
  </BaseModal>
);
